import script from "./SearchPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchPage.vue?vue&type=script&lang=ts&setup=true"

import "./SearchPage.vue?vue&type=style&index=0&id=56bd2be1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ljy\\Desktop\\workspace\\JIN-SOLUTIONS\\JMON_MES\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56bd2be1"]])

export default __exports__